@if (hasPermission()) {
  <div class="flex flex-col h-full">
    <div class="flex-1 overflow-hidden mb-4">
      <p-table
        [value]="checkIns"
        selectionMode="single"
        (onRowSelect)="viewEntity($event)"
        dataKey="id"
        [scrollable]="true"
        scrollHeight="flex"
        class="w-full h-full"
        [showLoader]="false"
        [loading]="checkInsLoading"
      >
        <ng-template #caption>
          <span class="text-xl font-bold"> {{ 'reservation.arrival' | transloco }}</span>
        </ng-template>
        <ng-template #header>
          <tr>
            <th>
              {{ 'property.unit_name' | transloco }}
            </th>
            <th>
              {{ 'property.guest_name' | transloco }}
            </th>
            <th>
              {{ 'reservation.arrival_date' | transloco }}
            </th>
            <th width="7%">
              {{ 'reservation.nights' | transloco }}
            </th>
            <th width="7%">
              {{ 'reservation.adults' | transloco }}
            </th>
            <th>
              {{ 'reservation.pending_payment' | transloco }}
            </th>
            <th>
              {{ 'reservation.platform' | transloco }}
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-reservation>
          <tr [pSelectableRow]="reservation">
            <td>{{ reservation.property__unit_name }}</td>
            <td>{{ reservation.guests?.[0]?.name || '---' }}</td>
            <td>
              {{ reservation.arrival_date ? (reservation.arrival_date | plainDate) : '' }}
              <app-time-and-note [time]="reservation.arrival_time" [note]="reservation.arrival_time_note"></app-time-and-note>
            </td>
            <td>{{ nightsNumber(reservation) }}</td>
            <td>{{ reservation.adults }}</td>
            <td>{{ reservation.pending_payment | currency: 'EUR' : 'symbol' : '1.2-2' }}</td>
            <td>{{ reservation.platform }}</td>
          </tr>
        </ng-template>
        <ng-template #loadingbody>
          @for (_ of skeletonRows; track $index) {
            <tr style="height: 46px">
              @for (col of checkInSkeletonColumns; track $index; let even = $even) {
                <td>
                  <p-skeleton [ngStyle]="{ width: even ? '40%' : '60%' }" />
                </td>
              }
            </tr>
          }
        </ng-template>
      </p-table>
    </div>
    <div class="flex-1 overflow-hidden">
      <p-table
        [value]="checkOuts"
        selectionMode="single"
        (onRowSelect)="viewEntity($event)"
        dataKey="id"
        [scrollable]="true"
        scrollHeight="flex"
        class="w-full h-full"
        [showLoader]="false"
        [loading]="checkOutsLoading"
      >
        <ng-template #caption>
          <span class="text-xl font-bold"> {{ 'reservation.departure' | transloco }}</span>
        </ng-template>
        <ng-template #header>
          <tr>
            <th>
              {{ 'property.unit_name' | transloco }}
            </th>
            <th>
              {{ 'property.guest_name' | transloco }}
            </th>
            <th>
              {{ 'reservation.departure_date' | transloco }}
            </th>
            <th>
              {{ 'reservation.deposit' | transloco }}
            </th>
            <th>
              {{ 'reservation.pending_payment' | transloco }}
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-reservation>
          <tr [pSelectableRow]="reservation">
            <td>{{ reservation.property__unit_name }}</td>
            <td>{{ reservation.guests?.[0]?.name || '---' }}</td>
            <td>
              {{ reservation.departure_date ? (reservation.departure_date | plainDate) : '' }}
              <app-time-and-note [time]="reservation.departure_time" [note]="reservation.departure_time_note"></app-time-and-note>
            </td>
            <td>{{ reservation.deposit | currency: 'EUR' : 'symbol' : '1.2-2' }}</td>
            <td>{{ reservation.pending_payment | currency: 'EUR' : 'symbol' : '1.2-2' }}</td>
          </tr>
        </ng-template>
        <ng-template #loadingbody>
          @for (_ of skeletonRows; track $index) {
            <tr style="height: 46px">
              @for (col of checkOutSkeletonColumns; track $index; let even = $even) {
                <td>
                  <p-skeleton [ngStyle]="{ width: even ? '40%' : '60%' }" />
                </td>
              }
            </tr>
          }
        </ng-template>
      </p-table>
    </div>
  </div>
} @else {
  <div class="relative flex flex-col md:flex-row md:h-screen h-full">
    <div class="w-full md:w-full bg-[#0F2E43] flex justify-center items-center h-full">
      <img src="assets/images/logo-big-white.svg" alt="Logo" class="w-64 mb-4" />
    </div>
  </div>
}
